export const datePicker = {
  format: 'dd/mm/yyyy',
  today: 'Hoje',
  clear: 'Limpar',
  done: 'Ok',
  selectMonths: true,
  weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  weekdaysLetter: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  monthsFull: [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ]
};

export const minDatePicker = { ...datePicker, min: true };

export const timePicker = {
  twelvehour: false,
  canceltext: 'Limpar',
  cleartext: 'Cancelar',
  donetext: 'Ok',
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/date-picker-options.ts